import { render, staticRenderFns } from "./block-acquiring-payment-info.vue?vue&type=template&id=6e865d5e&scoped=true&lang=pug&"
import script from "./block-acquiring-payment-info.vue?vue&type=script&lang=js&"
export * from "./block-acquiring-payment-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e865d5e",
  null
  
)

export default component.exports